import styled from '@emotion/styled'

interface DividerProps {
  margin: string
  lineWidth: number
}

const Divider: any = styled.hr<DividerProps>(
  ({ margin = '0 -30px', lineWidth = 1 }: DividerProps) => ({
    borderTop: `${lineWidth}px solid var(--geyser)`,
    padding: 0,
    margin,
  }),
)

export default Divider
